{
  "add_approval_step": "Новый этап подтверждения",
  "all_approvals_required_caption": "Каждый согласующий должен подтвердить заявку. Для важных решений",
  "all_approvals_required_title": "Требовать все согласования",
  "any_approvals_required_caption": "Заявка одобряется после первого согласующего. Для обычных запросов",
  "any_approvals_required_title": "Принять первое согласование",
  "approval_policy": "Политика согласования",
  "approval_process": "Процесс согласования",
  "approval_request": "Запрос на согласование",
  "approval_requests": "Запросы на согласование",
  "approval_request_changes_caption": "Изменения для {employee} в {process}",
  "approvals_completed": "{completed} из {total} {total, plural, one{согласование завершено} few{согласования завершено} many{согласований завершено} other{согласований завершено}}",
  "approvals": "Согласования",
  "approvers": "Согласующие",
  "category_create_title": "Создание процесса",
  "category_edit_title": "Редактирование процесса",
  "category_delete_title": "Удаление процесса",
  "category_delete_description": "Вы уверены, что хотите удалить эту категорию? Все политики согласования в ней также будут удалены",
  "approvals_description": "Настройка процессов рассмотрения запросов, требующих подтверждения",
  "approve": "Согласовать",
  "approve_as_admin": "Согласовать как администратор",
  "approve_as_admin_description": "Согласовать запрос сразу, минуя всех остальных проверяющих",
  "approve_required": "Необходимо подтверждение",
  "cancel_request": "Отменить запрос",
  "cancel_request_confirm_description": "Вы уверены, что хотите отменить запрос?",
  "changes_for": "Изменения для",
  "create_as_admin": "Создать как администратор",
  "create_as_admin_description": "Создать запрос, минуя все этапы согласования",
  "create_as_employee": "Создать как сотрудник",
  "create_as_employee_description": "Создать запрос, следуя назначенным этапам согласования",
  "create_title": "Создать новый процесс",
  "default_title": "Стандартный процесс согласования",
  "delete_request": "Удалить запрос",
  "edit_approval_step": "Редактирование этапа подтверждения",
  "edit_as_admin": "Редактировать как администратор",
  "edit_as_admin_description": "Редактировать запрос, минуя все этапы согласования",
  "new_hiring_plan_request_awaiting_approval": "Новый запрос на вакансию ожидает вашего решения",
  "new_value": "Новое значение",
  "edit_as_employee": "Редактировать как сотрудник",
  "edit_as_employee_description": "Редактировать запрос, следуя назначенным этапам согласования",
  "edit_substitution_rule": "Редактировать правило замещения",
  "edit_title": "Изменение процесса",
  "flow_skip_caption": "Этап без согласующего пропускается. Если пропущены все этапы, заявка одобряется",
  "flow_skip_title": "Пропускать этапы без согласующего",
  "in_category": "В категории «{category}»",
  "mandatory_approvals_title": "Требования к согласованию",
  "new_approval_request": "Новый запрос на согласование",
  "my_requests": "Мои заявки",
  "my_requests_empty_title": "Заявок ещё нет",
  "my_requests_empty_description": "Здесь появятся заявки, которые вы отправите на согласование.",
  "new_offer_request_awaiting_approval": "Новый оффер кандидату ожидает вашего решения",
  "no_approvers_caption": "Запрос будет подтвержден автоматически, так как к нему не назначены согласующие",
  "parallel_approval_caption": "Одновременное рассмотрение несколькими согласующими",
  "parallel_approval_title": "Параллельное согласование",
  "previous_value": "Предыдущее значение",
  "reject": "Отклонить",
  "reject_as_admin": "Отклонить как администратор",
  "reject_as_admin_description": "Отклонить запрос сразу, минуя всех остальных проверяющих",
  "request_approved": "Запрос подтверждён",
  "request_approved_on_date": "Запрос подтверждён {date}",
  "request_canceled": "Запрос отменён",
  "request_created": "Запрос создан",
  "request_details": "Детали запроса",
  "request_deleted": "Запрос удалён",
  "request_rejected": "Запрос отклонён",
  "request_rejected_on_date": "Запрос отклонён {date}",
  "requested_changes": "Запрошенные изменения",
  "request_status_approved": "Подтверждён",
  "request_status_awaiting": "На согласовании",
  "request_status_canceled": "Отменен",
  "request_status_queued": "В очереди",
  "request_status_rejected": "Отклонен",
  "request_status_skipped": "Пропущен",
  "review": "Рассмотреть",
  "select_create_as": "Выберите, как создать запрос",
  "select_edit_as": "Выберите, как редактировать запрос",
  "select_review_as": "Выберите, как рассматривать запрос",
  "sequence_approval_caption": "Последовательное рассмотрение несколькими согласующими",
  "sequence_approval_title": "Поэтапное согласование",
  "settings_description": "Создайте процессы согласования отсутствий и расходов",
  "settings_title": "Согласование заявок",
  "setup_caption_hiring_plan": "Запрос будет доступен, если у сотрудника включён модуль рекрутинга",
  "setup_caption_job_offer": "Настройте правила согласования для предложений о работе",
  "setup_caption_time_off": "Настройте правила согласования отсутствий",
  "step": "Этап {step}",
  "any_selected_employee_can_approve": "Согласует любой из выбранных",
  "multiple_approvers_require_sequence": "Несколько сотрудников в одном этапе доступны только при поэтапном согласовании",
  "steps_caption": "Определите кто и в каком порядке согласовывает заявки сотрудников",
  "steps_title": "Этапы согласования",
  "substitution_enabled_caption": "Настройте правило замещения, чтобы перенаправлять запрос, когда согласующий временно отсутствует",
  "substitution_enabled_title": "Включить замещение согласующего при отсутствии",
  "substitution_type_caption": "Действие при отсутствии",
  "time_off_approvals": "Отсутствия",
  "time_off_categories_caption": "Если ничего не выбрано, политика применяется ко всем типам отсутствий",
  "time_off_categories_title": "Типы отсутствий",
  "time_off_request": "Запрос на отсутствие",
  "workflow_request": "Запрос процесса",
  "~": "~",
  "comment_your_decision": "Прокомментируйте решение"
}
